import PasswordOffIcon from "@mui/icons-material/VisibilityOffOutlined";
import PasswordIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  InputAdornment,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Input,
} from "../../components";
import { Form, useForm } from "../../components/form/UseForm";
// import { onSignIn,forgotPassword } from "../../redux/actions";
import Header from "../../components/Header";
import { OnLoginAsync, whoamiAPI } from "../../redux/actions";
import { useAppDispatch } from "../../store/customHooks";

const initialFValues = {
  LoginName: "",
  Password: "",
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [error, setError] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("LoginName" in fieldValues)
      temp.LoginName = fieldValues.LoginName ? "" : "This field is required.";

    if ("Password" in fieldValues)
      temp.Password = fieldValues.Password ? "" : "This field is required.";

    setErrors({
      ...temp,
    });

    // Check if any field has error return false else true.
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };
  // Custom useForm hook.
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm({ initialFValues, validateOnChange: true, validate });

  let authData:any = localStorage.getItem("AUTH_DATA")
  authData = JSON.parse(authData)
  // useAppSelector((state: any) => state.auth.authData);

  useEffect(() => {
    whoami()
    let auth = localStorage.getItem("AUTH_DATA")
    if (auth) {
      navigate("/dashboard")
    }
    window.onpopstate = function (event) {
      window.history.go(1);
    };
  }, []);

  const whoami=async()=>{
    await dispatch(whoamiAPI(""))
  }
  const handleLogin = async (e: any) => {
    e.preventDefault()

    const payload = {
      Username: values.LoginName,
      Password: values.Password
    };
    const res: any = await dispatch(OnLoginAsync(payload));
    if (res?.payload?.statusCode===200) {
      if(res?.payload?.data?.validCredentials){
      navigate("/dashboard");
      dispatch({ type: "dashBoardListAsync", payload: {} });
      localStorage.setItem("AUTH_DATA", JSON.stringify(res.payload?.data));
      setError("");
      }else{
        setError("User not found")
      }
    } else {
      setError("User not found");
    }
  };

  const onInputChange = (e: any) => {
    setError("")
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    validate({ [name]: value });

  };

  const togglePassword = (e: any) => {
    e.preventDefault();
    setIsPasswordVisible(!isPasswordVisible);
  };



  return (
    <Grid container>
      <Grid item xs={12}>
        <Header />
      </Grid>
      <Grid container marginTop="100px">
        <Grid item sm={4} xs={12}></Grid>
        <Grid item xs={12} sm={4}>
          <Card>
            <Form>
              <CardContent style={{ padding: "20px" }}>
                <CardHeader
                  title={
                    <Typography
                      variant={"h5"}
                      style={{
                        color: "#333996",
                        textAlign: "center",
                      }}
                    >
                      Sign In
                    </Typography>
                  }
                ></CardHeader>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Input
                      name="LoginName"
                      label="Login Name"
                      placeholder="Enter Login Name"
                      value={values.LoginName}
                      onChange={onInputChange}
                      error={errors.LoginName}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      name="Password"
                      label="Password"
                      placeholder="Enter Password"
                      value={values.Password}
                      onChange={onInputChange}
                      error={errors.Password}
                      type={!isPasswordVisible ? "password" : "text"}
                      size="small"
                      inputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={(e) => {
                              togglePassword(e);
                            }}
                          >
                            {isPasswordVisible && (
                              <PasswordIcon style={{ cursor: "pointer" }} />
                            )}
                            {!isPasswordVisible && (
                              <PasswordOffIcon style={{ cursor: "pointer" }} />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions style={{ justifyContent: "center", paddingBottom: "4%" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Button
                    name="LOGIN"
                    disabled={values.LoginName && values.Password ? false : true}
                    style={{ backgroundColor: "#333996" }}
                    type="submit"
                    onClick={(e: any) => {
                      handleLogin(e);
                    }}
                  />
                  {error && (
                    <Typography
                      style={{
                        paddingTop: "4%",
                        color: "red",
                        fontSize: "14px",
                        textAlign: "center"
                      }}
                    >
                      {error}
                    </Typography>
                  )}
                </div>
              </CardActions>
            </Form>
          </Card>
        </Grid>
        <Grid item sm={4} xs={12}></Grid>
      </Grid>
    </Grid>
  );
};

export default Login;
